import { t } from '@lingui/core/macro';
import { brands, BrandType } from 'noddi-types';
import { SidebarMenuSection } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { useCustomerGroupRole } from './useCustomerGroupRole';
import { useHasBrandDiscounts } from './useHasBrandDiscounts';
import { useIsCurrentUserGroupAnOrganization } from './useIsCurrentUserGroupOrg';

export const useNavItems = (brand: BrandType) => {
  const isOrgUserGroup = useIsCurrentUserGroupAnOrganization();
  const { currentUserGroupId, userData } = useAuthContext();
  const currentUserGroup = userData?.user.userGroups?.find((userGroup) => userGroup.id === currentUserGroupId);
  const role = useCustomerGroupRole();
  const { hasBrandDiscounts, hasReferralProgram, isPending: isBrandPromotionsPending } = useHasBrandDiscounts();

  const hideTireOffer = brand === brands.carglass || brand === brands.elitebilvask;

  const homeSection: SidebarMenuSection = {
    items: [
      {
        path: customerRoutes.homepage.getPath(),
        title: t`My page`,
        icon: 'CircleUserRound'
      }
    ]
  };

  if (!currentUserGroup || (role.kind !== 'personal' && role.kind !== 'organizationAdmin')) {
    return [homeSection];
  }

  const navItems: SidebarMenuSection[] = [
    homeSection,
    {
      items: [
        {
          path: customerRoutes.bookings.getPath({}),
          title: t`Bookings`,
          icon: 'Calendar'
        }
      ]
    },
    {
      items: [
        {
          path: isOrgUserGroup ? customerRoutes.fleet.getPath() : customerRoutes.myCars.getPath(),
          title: isOrgUserGroup ? t`Fleet` : t`Cars`,
          icon: 'Car'
        }
      ]
    },
    {
      items: [
        {
          path: customerRoutes.tireOfferHomePage.getPath(),
          title: t`Tire offer`,
          icon: 'Mail',
          hide: hideTireOffer
        }
      ]
    },
    {
      items: [
        {
          path: customerRoutes.organizationMembers.getPath(),
          title: t`Members and drivers`,
          icon: 'Users',
          hide: !isOrgUserGroup
        }
      ]
    },
    {
      items: [
        {
          path: customerRoutes.discounts.getPath(),
          title: t`Discounts`,
          icon: 'Star',
          hide: isBrandPromotionsPending || !hasBrandDiscounts
        }
      ]
    },
    {
      items: [
        {
          path: customerRoutes.myReferrals.getPath(),
          title: t`Invite friends`,
          icon: 'Gift',
          hide: isBrandPromotionsPending || !hasReferralProgram
        }
      ]
    }
  ];

  return navItems;
};
